import { Serializer } from 'jsonapi-serializer';
import { UserGrantPayload } from '../interfaces/user-grant-payload.interface';

const RELATIONSHIP_TYPES: Record<string, string> = {
	user: 'User',
};

const serializer = new Serializer('UserGrant', {
	id: 'id',
	keyForAttribute: (attr: string) => attr,
	pluralizeType: false,
	attributes: ['permission', 'user'],
	typeForAttribute: (attr: string) => RELATIONSHIP_TYPES[attr] ?? attr,
	user: { ref: 'id' },
	transform(record: UserGrantPayload & { id: string }) {
		return {
			id: record.id,
			permission: record.permission,
			user: { id: record.userId },
		};
	},
});

export function serializeUserGrant(grant: UserGrantPayload, id: string) {
	return serializer.serialize({ ...grant, id });
}
